<template>
  <div class="apps-dialog">
    <el-dialog title="编辑应用信息" width="75%" :visible.sync="tempAppsInfo.dialogVisible" v-if="tempAppsInfo.dialogVisible" custom-class="project-info-set" @close="dialogClose">

      <el-collapse v-model="activeNames" @change="handleChange" class="p-collapse">
        <el-collapse-item title="应用基本信息" name="1">
          <el-form :model="formData" label-position="right" label-width="110px" ref="form" size="mini">
            <el-form-item v-for="(item, index) of formData" :key="index" :label="item.label" :rules="formData[index].rules" :prop="'[' + index + '].value'">
              <el-input v-model="formData[index].value" :type="formData[index].type"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" plain @click="save">保存</el-button>
            </el-form-item>
          </el-form>
        </el-collapse-item>

        <el-collapse-item title="应用功能" name="2">
          <el-form label-width="110px" size="mini">
            <!-- <el-form-item label="应用模块" :rules="pModule.rules" prop="pModule">:model="pModule" ref="pForm"
              <el-select v-model="pModule.pModule" placeholder="请选择应用的模块" multiple filterable class="select-multiple">
                <el-option v-for="(item, index) in projectInfo.projectModule" :key="index" :label="item.name" :value="item.id"></el-option>
              </el-select>
            </el-form-item> -->
            <el-form-item label="应用功能">
              <div class="tree-info" >
                <el-tree class="roles-tree" :data="projectTreeModule" show-checkbox default-expand-all
                node-key="id" ref="rTree" highlight-current :props="defaultProps">
                </el-tree>
              </div>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" plain @click="savePModule">保存</el-button>
            </el-form-item>
          </el-form>
        </el-collapse-item>

        <el-collapse-item title="挂载网关" name="3">
          <el-form :model="pGateway" ref="gForm" label-width="110px" size="mini">
            <el-form-item label="应用挂载网关" :rules="pGateway.rules" prop="pGateway">
              <el-select size="mini" v-model="pGateway.pGateway" placeholder="请选择网关" multiple filterable class="select-multiple">
                <el-option v-for="(item, index) in projectInfo.tenantGateway" :key="index" :label="item.name" :value="item.id.id"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" plain @click="saveGatway">保存</el-button>
            </el-form-item>
          </el-form>
        </el-collapse-item>

        <el-collapse-item title="其他设置" name="4">
          <div>
            <el-form label-width="110px" size="mini">
              <el-form-item label="抄表时间">
                <el-time-select v-model="readMeterTime" :editable="false" :clearable="false"
                  :picker-options="{start: '00:00',step: '00:30',end: '23:59'}"></el-time-select>
              </el-form-item>
              <el-form-item>
                <el-button type="primary">保存</el-button>
              </el-form-item>
              <el-form-item label="设备异常时间" prop="alarmTime">
                <div>
                  <span class="msg">设备掉线</span>
                  <el-input-number v-model="alarmTime" placeholder=""></el-input-number>
                  <span class="msg">分钟，发出告警</span>
                  <!-- <el-button type="primary" @click="saveAlarmTime" class="suffix-save-btn">保存</el-button> -->
                </div>
              </el-form-item>
              <el-form-item>
                  <el-button type="primary" @click="saveAlarmTime" >保存</el-button>
              </el-form-item>
            </el-form>
          </div>
        </el-collapse-item>
      </el-collapse>
    </el-dialog>
  </div>
</template>

<script>
import { saveProject, getProjectTreeMenu, setProjectModule, getProjectGateway, setProjectGateway } from '@/api/project-controller'
import { saveEntityAttributesV1, getAttributes } from '@/api/telemetry-controller'
import { removeSlash } from '@/utils/removeIdSlash.js'

export default {
  name: 'addAppsDialog',
  inject: ['reload'],
  props: [
    'tempAppsInfo', 'projectInfo'
  ],
  data () {
    const checkName = (rules, value, callback) => {
      if (value.trim() === '') {
        callback(new Error('名称不可为空，请输入'))
      } else {
        callback()
      }
    }
    return {
      activeNames: ['2', '3'],
      projectId: '',
      formData: {
        title: {
          label: '应用名称',
          value: '',
          hasValue: false,
          rules: [
            { required: true, message: '请输入应用名称', trigger: 'blur' },
            { max: 12, message: '应用名称不超过12位', trigger: 'blur' },
            { validator: checkName, trigger: 'blur' }
          ],
          type: 'string'
        }
        // email: {
        //   label: '邮箱',
        //   value: '',
        //   hasValue: false,
        //   rules: [
        //     // { required: true, message: '请输入用户邮箱', trigger: 'blur' },
        //     { type: 'email', message: '请输入正确邮箱地址', trigger: 'blur' }
        //   ],
        //   type: 'string'
        // },
        // phone: {
        //   label: '联系手机',
        //   value: '',
        //   hasValue: false,
        //   rules: [
        //     { validator: validatePhone, trigger: 'blur' }
        //   ],
        //   type: 'string'
        // },
        // country: {
        //   label: '国家',
        //   value: '',
        //   hasValue: false,
        //   type: 'string',
        //   rules: [
        //     { max: 20, message: '输入不可超过20位', trigger: 'blur' }
        //   ]
        // },
        // state: {
        //   label: '省',
        //   value: '',
        //   hasValue: false,
        //   rules: [
        //     { max: 20, message: '输入不可超过20位', trigger: 'blur' }
        //   ],
        //   type: 'string'
        // },
        // city: {
        //   label: '城市',
        //   value: '',
        //   hasValue: false,
        //   rules: [
        //     { max: 20, message: '输入不可超过20位', trigger: 'blur' }
        //   ],
        //   type: 'string'
        // },
        // address: {
        //   label: '地址',
        //   value: '',
        //   hasValue: false,
        //   rules: [
        //     { max: 40, message: '输入不可超过40位', trigger: 'blur' }
        //   ],
        //   type: 'string'
        // },
        // zip: {
        //   label: '邮编',
        //   value: '',
        //   hasValue: false,
        //   rules: [
        //     { validator: postcode, trigger: 'blur' },
        //     { max: 20, message: '名称不超过20位', trigger: 'blur' }
        //   ],
        //   type: 'string'
        // },
        // region: {
        //   label: '地区',
        //   value: '',
        //   hasValue: false,
        //   rules: [
        //     // { validator: textControl, trigger: 'blur' },
        //     { max: 40, message: '输入不可超过40位', trigger: 'blur' }
        //   ],
        //   type: 'string'
        // }
      },
      defaultProps: {
        children: 'children',
        label: 'label'
      },
      projectTreeModule: [],
      pModule: {
        pModule: [],
        rules: [
          { required: true, message: '请选择应用的功能', trigger: 'blur' }
        ]
      },
      pGateway: {
        pGateway: [],
        rules: [
          { required: true, message: '请选择挂载网关', trigger: 'blur' }
        ]
      },
      readMeterTime: '00:00',
      alarmTime: 15,
      isSave: false,
      rules: {
        alarmTime: [
          // { validator: validateNumber, trigger: 'blur' },
          { required: true, message: '请输入设备异常时间', trigger: 'blur' }
        ]
      }
    }
  },
  created () {
    this.projectId = this.tempAppsInfo.data.id.id
    console.log(this.tempAppsInfo, this.projectInfo, '----edit p')
    // this.formData = Object.assign({}, this.tempAppsInfo)
    // 模块
    this.getTree(this.projectInfo.projectModule)
    console.log(this.projectTreeModule, 111111111)
    getProjectTreeMenu(this.projectId).then(res => {
      const chackId = res.data
      console.log(chackId, '----已选的id')
      if (chackId.length > 0) {
        this.$refs.rTree.setCheckedKeys(chackId)
      }
    })
    // 网关
    getProjectGateway(removeSlash(this.projectId)).then(res => {
      console.log('获取project下已挂载的网关', res.data)
      for (const item of res.data) {
        this.pGateway.pGateway.unshift(item.id.id)
      }
    })
    // get 抄表时间 掉线告警时间
    getAttributes('PROJECT', this.projectId).then(res => {
      for (const item of res.data) {
        if (item.key === 'readMeterTime') {
          this.readMeterTime = item.value
        }
        if (item.key === 'alarmTime') {
          this.alarmTime = item.value
        }
      }
    })
    // 模块
    // this.pModule.pModule = this.projectInfo.tempPModule
    // 基本信息
    for (const item in this.tempAppsInfo.data) {
      if (this.formData[item]) {
        this.formData[item].value = this.tempAppsInfo.data[item]
      }
    }
  },
  methods: {
    getTree (data) {
      for (const item of data) {
        item.label = item.name
        item.children = item.child
        if (item.child && item.child.length > 0) {
          this.getTree(item.child)
          this.projectTreeModule.push(item)
        } else {
          // this.projectTreeModule.push(item)
        }
      }
    },
    save () {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.formData.title.value = this.formData.title.value.trim()
          for (const item of this.projectInfo.projectData) {
            if (item.title === this.formData.title.value) {
              this.$message.error('应用名称不可重复')
              return false
            }
          }
          // this.tempAppsInfo.data.name = this.formData.title.value
          this.tempAppsInfo.data.title = this.formData.title.value
          // for (const item in this.formData) {
          //   if (this.formData[item]) {
          //     this.tempAppsInfo.data[item] = this.formData[item].value
          //   }
          // }
          // if (this.tempAppsInfo.data.email) {
          //   this.tempAppsInfo.data.email = this.formData.email.value.toLowerCase()
          // }
          const params = Object.assign({}, this.tempAppsInfo.data)
          params.name = params.title
          saveProject(params).then(res => {
            this.messageInfo('success', '应用基本信息 保存成功')
            // this.tempAppsInfo.dialogVisible = false
            this.isSave = true
          })
        } else {
          this.$message.error('请按提示输入信息')
          return false
        }
      })
    },
    savePModule () {
      const checkMenu = this.$refs.rTree.getCheckedKeys()
      const saveRoleMenu = {
        data: checkMenu,
        projectId: this.projectId
      }
      // 模块关联判断 暂缺
      setProjectModule(saveRoleMenu).then(res => {
        this.messageInfo('success', '应用功能 保存成功')
        this.isSave = true
      })
      // this.$refs.pForm.validate((valid) => {
      //   if (valid) {
      //     const params = {
      //       data: this.pModule.pModule,
      //       projectId: this.projectId
      //     }
      //     // 模块关联判断 暂缺
      //     // setProjectModule(params).then(res => {
      //     //   this.messageInfo('success', '模块 保存成功')
      //     //   this.isSave = true
      //     // })
      //   } else {
      //     return false
      //   }
      // })
    },
    saveGatway () {
      this.$refs.gForm.validate((valid) => {
        if (valid) {
          const params = {
            data: [],
            projectId: removeSlash(this.projectId)
          }
          this.pGateway.pGateway.filter(v => {
            const item = {
              id: v,
              entityType: 'DEVICE'
            }
            params.data.push(item)
          })
          console.log(params, '网关挂载')
          setProjectGateway(params).then(res => {
            this.messageInfo('success', '网关挂载 保存成功')
            this.isSave = true
          })
        } else {
          return false
        }
      })
    },
    saveReadMeterTime () {
      saveEntityAttributesV1('PROJECT', this.projectId, { readMeterTime: this.readMeterTime }).then(res => {
        this.messageInfo('success', '抄表时间 保存成功')
      })
    },
    saveAlarmTime () {
      saveEntityAttributesV1('PROJECT', this.projectId, { alarmTime: this.alarmTime }).then(vRes => {
        this.messageInfo('success', '设备异常时间 保存成功')
      })
    },
    resetChecked () {
      this.$refs.rTree.setCheckedKeys([])
    },
    dialogClose () {
      if (this.isSave) {
        // this.tempAppsInfo.dialogVisible = false
        this.reload()
      }
    },
    refresh () {
      this.reload()
    },
    handleChange () {
      //
    },
    messageInfo (type, info) {
      this.$message({
        type: type,
        message: info
      })
    }
  }
}
</script>

<style lang="scss">
.apps-dialog {
  .apps-form {
    .name-input {
      width: 55%;
    }
  }
}
.project-info-set {
  // height: 100%;
  // overflow-y: auto;
  .p-collapse {
    width: 100%;
  }
  .select-multiple {
    width: 95%;
  }
  .msg {
    color: #1e99e4;
  }
  .suffix-save-btn {
    margin-left: 15px;
  }
}
</style>
